module.exports = __webpack_public_path__ + "img/dotsicon.22ba0a3b.svg";